import { OTA_Primary } from "./ota_primary.model";

export class OTA_Customer {
    public primary = new OTA_Primary();
}
